import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';

import { usePicklistsFeatureGate } from '../../../../../feature-gates/use-picklists-feature-gate';
import {
  labelQuePrintLabelStart,
  labelQuePrintPackingSlipStart,
  labelQuePrintPickListStart,
  labelQueArchiveBatches,
} from '../../../../../store/label-que/label-que.actions';
import style from '../style.module.less';

export const TileFooterActions = memo(({ batchId }) => {
  const dispatch = useDispatch();
  const { isFeatureEnabled: hasPickListFeature } = usePicklistsFeatureGate();

  const onPrintBatch = useCallback(() => {
    dispatch(labelQuePrintLabelStart(batchId));
  }, [batchId, dispatch]);

  const onPrintPackingSlip = useCallback(() => {
    dispatch(labelQuePrintPackingSlipStart(batchId));
  }, [batchId, dispatch]);

  const onPrintPickList = useCallback(() => {
    dispatch(labelQuePrintPickListStart(batchId));
  }, [batchId, dispatch]);

  const onArchiveBatch = useCallback(() => {
    dispatch(labelQueArchiveBatches([batchId]));
  }, [batchId, dispatch]);

  return (
    <div className={classnames(style['batch-tile-footer'], style['tile-mid-section'])}>
      <Button onClick={onPrintBatch} theme='link'>
        <FormattedMessage defaultMessage='Label' description='batchTileFooter.printPackingLabel' id='J+bDm0' />
      </Button>
      <div className={style['footer-spacer']}>|</div>
      <Button onClick={onPrintPackingSlip} theme='link'>
        <FormattedMessage defaultMessage='Packing Slip' description='batchTileFooter.printPackingSlip' id='tbn7v7' />
      </Button>
      {hasPickListFeature && (
        <>
          <div className={style['footer-spacer']}>|</div>
          <Button onClick={onPrintPickList} theme='link'>
            <FormattedMessage defaultMessage='Pick List' description='batchTileFooter.printPickList' id='wb6uY7' />
          </Button>
        </>
      )}
      <div className={style['footer-spacer']}>|</div>
      <Button onClick={onArchiveBatch} theme='link'>
        <FormattedMessage defaultMessage='Archive' description='batchTileFooter.archive' id='W6ih5l' />
      </Button>
    </div>
  );
});
